import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '36ch',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  }
}));

export default function AlignItemsList(props) {
  const classes = useStyles();
  return (
    <List className={classes.root}>
      {props.items && props.items.map(item => (
        <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt={item.byUser.firstName + ' ' + item.byUser.lastName} src={item.byUser.thumbnailURL} />
        </ListItemAvatar>
        <ListItemText
          secondary={
            <React.Fragment>
              <Typography
                component="span"
                variant="body2"
                color="textPrimary"
              >
               {item.byUser.firstName + ' ' + item.byUser.lastName} {new Date(item.createdTime).toLocaleTimeString("en-US",{
     month:"2-digit",
     day:"2-digit",
       hour12 : true,
       hour:  "numeric",
       minute: "numeric",
       seconds:"numeric"
    })}
              </Typography>
              <pre>
              {item.comment}
              </pre>
            </React.Fragment>
          }
        />
        <Divider variant="inset" component="li" />
      </ListItem>))}
    </List>
  );
}